<template>
	<el-dialog title="教师详情" :append-to-body="true" :visible.sync="centerDialogVisible" width="60%" center
		@close="onClose">
		<div class="dialog-content">
			<div class="top">
				<img :src="tearcher.avatars"></img>
				<div class="right">
					<p>{{tearcher.name}} </p>
					<p>{{tearcher.join_time}} </p>
					<p>{{tearcher.graduation||'暂无简介'}}</p>
				</div>
			</div>
			<div class="content">
				<p>{{tearcher.content||''}}</p>
			</div>
		</div>
	</el-dialog>
</template>
<script>
	export default {
		name: "teacherDialog",
		components: {},
		computed: {},
		data() {
			return {
				centerDialogVisible: false,
				tearcher_id: '',

				tearcher: {},
			};
		},
		methods: {
			async onOpen(id) {
				this.tearcher_id = id;
				console.log("onOpen ===> ", this.tearcher_id);
				await this.getTearcherInfo();
				this.centerDialogVisible = true;
			},
			onClose() {
				this.centerDialogVisible = false;
				if (this.checkInterval) clearInterval(this.checkInterval);
			},
			async getTearcherInfo() {
				console.log("this.teacher_id ===> ", this.tearcher_id);
				const infoRes = await this.$zkHttp.index$getTeacherDetail({
					teacher_id: this.tearcher_id
				});
				console.log("infoRes ===> ", infoRes);
				if (infoRes) {
					this.tearcher = infoRes;
				}
			},
		}
	}
</script>
<style scoped lang="scss">
	* {
		margin: 0;
		padding: 0;
	}

	::v-deep .el-dialog {
		min-width: 720px;
		max-width: 800px;

		.el-dialog__header .el-dialog__title {
			font-weight: bold;
			letter-spacing: 4px;
		}

		.dialog-content {
			width: 100%;
			display: flex;
			flex-direction: column;

			.top {
				width: 100%;
				display: flex;
				flex-direction: row;

				>img {
					width: 240px;
					background: #f4f4f4;
					object-fit: cover;
				}

				>.right {
					padding: 0 30px;
					width: calc(100% - 300px);
					display: flex;
					flex-direction: column;

					p:first-child {
						padding: 20px 0;
						width: 100%;
						font-weight: bold;
						font-size: 20px;
						color: #333;
					}

					p:not(:first-child) {
						width: 100%;
						font-weight: 400;
						font-size: 16px;
						color: #999;
					}
				}
			}

			.content {
				margin-top: 20px;
				width: 100%;

				p {
					width: 100%;
					text-indent: 2em;
					font-weight: 400;
					font-size: 16px;
					color: #999;
				}
			}
		}
	}
</style>